import FondationsServiceModel               from '@/models/FondationsServiceModel';
import { computed }                         from 'mobx';
import { decodeToken }                      from '@/helpers/JwtTokenHelper';
import { getUserRightsFromTokenData }       from '@/helpers/JwtTokenHelper';
import { getRoleIdentifiersFromUserRights } from '@/helpers/JwtTokenHelper';

export default class LoginCheckModel extends FondationsServiceModel {
	static get path(): string {
		return '/login_check';
	}

	@computed get token(): string {
		return this.get('token', '');
	}

	@computed get refreshToken(): string {
		return this.get('refresh_token', '');
	}

	@computed get tokenData() {
		return decodeToken(this.token);
	}

	@computed get userRights() {
		return getUserRightsFromTokenData(this.tokenData);
	}

	@computed get roleIdentifiers() {
		return getRoleIdentifiersFromUserRights(this.userRights);
	}
}
